import { BrandText } from 'design-configuration/components'

interface OverlineHeaderProps {
  text: string
  className?: string
}

export function OverlineHeader({ text, className }: OverlineHeaderProps): React.ReactElement {
  return (
    <div className={className}>
      <div
        className="w-2xl mb-md h-[3px]"
        style={{ background: 'linear-gradient(90deg, #FD0045 0%, #FD02D4 50%, #A000FD 100%)' }}
      />
      <BrandText className="mb-2xs uppercase">{text}</BrandText>
    </div>
  )
}
